/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{border-radius:5px}.close-button[_ngcontent-%COMP%]{margin-left:auto}.license-link[_ngcontent-%COMP%]{text-align:center;color:#26809d}.submit[_ngcontent-%COMP%]{margin-left:auto}.field-row[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/home-page/license-modal/license-modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js